import { useQuery } from 'react-query';
import { SERVICE_VISITS } from '../../constants/reactQuery.keys';
import Patients from '../../services/Patients';

export function useServiceVisits(patientId: string) {
  return useQuery([SERVICE_VISITS, patientId], () => Patients.getServiceVisits(patientId), {
    refetchOnWindowFocus: false,
  });
}
